'use client';
import { useRef } from 'react';
import type { FeedDetailConfig, InspirationType, MiniVideoType, ShortFilmType, TutorialType } from '@/app/types';
import { transformExploreDetail } from '@/app/utils';
import { ImageInspiration } from './components/ImageInspiration';
import { Inspiration } from './components/Inspiration';
import { MiniVideoInspiration } from './components/MiniVideoInspiration';
import { ShortFilm } from './components/ShortFilm';
import { ThumbScrollList } from './components/ThumbScrollList';
import { Tutorial } from './components/Tutorial';
import type { ViduV1ExploreDetailProReply } from './types';

interface FeedDetailProps {
  data?: ViduV1ExploreDetailProReply;
  config?: FeedDetailConfig;
  loading?: boolean;
}

export const FeedDetail = ({ data, config, loading = false }: FeedDetailProps) => {
  const { value } = data ? transformExploreDetail(data) || {} : { value: undefined };

  // 媒体区域引用，用于滚轮事件监听
  const mediaAreaRef = useRef<HTMLElement>(null);

  if (loading || !data) {
    return (
      <div className="flex size-full">
        <div className="relative size-full" />
        <ThumbScrollList {...config?.thumbScrollListConfig} mediaAreaRef={mediaAreaRef} />
      </div>
    );
  }

  const renderContent = () => {
    switch (data.type) {
      case 'media_asset':
        return <Inspiration {...config} inspiration={value as InspirationType} mediaAreaRef={mediaAreaRef} />;
      case 'image_asset':
        return <ImageInspiration {...config} inspiration={value as InspirationType} mediaAreaRef={mediaAreaRef} />;
      case 'short_film':
        return <ShortFilm {...config} shortFilm={value as ShortFilmType} mediaAreaRef={mediaAreaRef} />;
      case 'tutorial':
        return <Tutorial {...config} tutorial={value as TutorialType} mediaAreaRef={mediaAreaRef} />;
      case 'mini_video':
        return <MiniVideoInspiration {...config} miniVideo={value as MiniVideoType} mediaAreaRef={mediaAreaRef} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex size-full">
      <div className="relative size-full">{renderContent()}</div>
      <ThumbScrollList {...config?.thumbScrollListConfig} mediaAreaRef={mediaAreaRef} />
    </div>
  );
};
